export const AVATARS = ['worm', 'fox', 'owl', 'cat', 'bear', 'bunny', 'frog', 'panda'] as const;

export type Avatar = (typeof AVATARS)[number];

export const AVATAR_COLORS = ['orange', 'sky', 'emerald', 'violet', 'rose', 'amber'] as const;

export type AvatarColor = (typeof AVATAR_COLORS)[number];

export const FULL_NAME_LIMIT = 80;

export function nextAvatar(taken: readonly Avatar[]): { avatar: Avatar; color: AvatarColor } {
  const index = taken.length;
  const avatar = AVATARS.find((candidate) => !taken.includes(candidate)) ?? AVATARS[0];
  return { avatar, color: AVATAR_COLORS[index % AVATAR_COLORS.length] ?? AVATAR_COLORS[0] };
}
